module.exports = __webpack_public_path__ + "static/media/S3N4-1.c561998b.svg";